export enum UtilisateurProjection {
  DEFAULT = 'DEFAULT',
  INSCRIPTION = 'INSCRIPTION',
  IDENTITY = 'IDENTITY',
  ANNUAIRE = 'ANNUAIRE',
}